// removed by extract-text-webpack-plugin
module.exports = {"success":"_2TvfH _2yb9H _2kRiW","error":"IH1rB _2yb9H _3tMFy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/notif/style.css
// module id = 896
// module chunks = 0